module.exports = __webpack_public_path__ + "img/lab-word-icon.4e125577.svg";